import { IToggleRoomModalSaving } from '../../../actions/bookingCalendar/roomModal/toggleRoomModal'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IToggleRoomModalSaving,
): IBookingCalendarStore {
  return {
    ...state,
    roomModal: {
      ...state.roomModal,
      isSaving: action.toggle,
    },
  }
}
